export const trackEvent = (eventName, extraData) => {
    try {
        window?.heap?.track(eventName, extraData);
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.log('could not track heap event');
    }
};
